/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of view for displaying data
 * @export
 */
export const WebApiModelsEnumerationTypesViewType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesViewType = typeof WebApiModelsEnumerationTypesViewType[keyof typeof WebApiModelsEnumerationTypesViewType];


export function WebApiModelsEnumerationTypesViewTypeFromJSON(json: any): WebApiModelsEnumerationTypesViewType {
    return WebApiModelsEnumerationTypesViewTypeFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesViewTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesViewType {
    return json as WebApiModelsEnumerationTypesViewType;
}

export function WebApiModelsEnumerationTypesViewTypeToJSON(value?: WebApiModelsEnumerationTypesViewType | null): any {
    return value as any;
}

